import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polyline", {
  strokeWidth: 2,
  stroke: "currentColor",
  fill: "none",
  points: "5.74865723 10.3518066 9.29565517 13.9886531 15.2611084 5.61889648"
});

var SvgPermissionSmallTick = function SvgPermissionSmallTick(props) {
  return _ref;
};

export default SvgPermissionSmallTick;